import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTASection({
  title = 'Porozmawiajmy o Twojej stronie',
  description = 'Rozmowa jest bezpłatna i bez zobowiązań. Chętnie odpowiemy na wszystkie Twoje pytania.',
  primaryLabel = 'Umów bezpłatną rozmowę',
  primaryTo = '/kontakt',
  secondaryLabel = 'Zobacz cennik',
  secondaryTo = '/cennik',
}) {
  return (
    <section className="py-24 bg-gradient-to-r from-[#2d4059] to-[#6b9bc3]">
      <div className="max-w-[100rem] mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-extrabold text-white mb-6">
          {title}
        </h2>
        <p className="text-lg sm:text-xl text-white/90 mb-12 max-w-3xl mx-auto font-paragraph">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {primaryLabel && (
            <Link
              to={primaryTo}
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#e74c3c] hover:bg-[#d44332] text-white text-lg font-semibold rounded-md shadow-lg transition-all"
            >
              {primaryLabel}
              <ArrowRight className="ml-1 h-5 w-5" />
            </Link>
          )}
          {secondaryLabel && (
            <Link
              to={secondaryTo}
              className="inline-flex items-center px-8 py-4 border border-white text-white hover:bg-white hover:text-[#2d4059] text-lg rounded-md transition-all"
            >
              {secondaryLabel}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
